<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <div v-bem:content>
      <span v-bem:close @click="$emit('close-clicked')">&times;</span>
      <p v-bem:title>{{$t('steps.equipment.label')}}</p>
      <div>
        <perfect-scrollbar :options="{wheelPropagation: false}">
          <ul v-bem:list>
            <li v-for="(equipement, index) in equipements" :key="index">{{equipement}}</li>
          </ul>
        </perfect-scrollbar>
      </div>
      <div class="footer-btn">
        <button class="button button--primary" @click="$emit('close-clicked')"><span class="button__text">{{$t('cta.close')}}</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

export default {
  name: 'EquipementsPopin',
  components: {
    PerfectScrollbar
  },
  computed: {
		...mapGetters([
      'version'
    ]),
    equipements() {
      let list = this.version[this.$i18n.locale === 'ar' ? 'equipements_ar' : 'equipements']
      list = (list && list.length) ? list.split(';').map(item => item.trim()) : []
      return list
    }
  }
}
</script>


<style lang="scss">
.equipements-popin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999999;
  background-color: rgba($black, 0.7);
  &__content {
    @extend %transform-center;
    background-color: $white;
    width: 95%;
    max-width: rem(520);
    padding: rem(30) rem(4) rem(16);
  }
  &__close {
    position: absolute;
    top: rem(4);
    right: rem(12);
    @include font-size(22);
    font-weight: bold;
    cursor: pointer;
  }
  &__title {
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    @include font-size(22);
    margin-bottom: rem(16);
    span {
      display: block;
      color: $dark-gray;
      @include font-size(14);
      font-weight: normal;
      text-transform: initial;
      max-width: rem(360);
      margin: rem(4) auto rem(16);
    }
  }
  .ps {
    height: rem(380) !important;
    &__rail-x,
    &__rail-y {
      display: block !important;
      opacity: 0.6 !important;
      height: rem(380) !important;
    }
    &__rail-x {
      width: 15px !important;
    }
    &__thumb-y {
      min-height: rem(60);
    }
    &__rtl {
      .ps__rail-x,
      .ps__rail-y {
        right: unset !important;
        left: 0 !important;
      }
    }
  }
  &__list {
    padding: rem(16);
    padding-left: rem(32);
    display: block;
    list-style-type: disc;
    li {
      margin: rem(16) 0;
    }
  }
  &--rtl {
  }
  .footer-btn {
    text-align: center;
    margin-top: rem(16);
  }
}
</style>